import React, { useContext } from "react";

import { useNavigate } from "react-router-dom";

import BtnPlain from "../../../../../../../Components/Buttons/BtnPlain";

import { ActionBtn } from "../../../../../../../Components/FinalTable";

import { FiEdit2 } from "react-icons/fi";

import { FaRegTrashAlt } from "react-icons/fa";

import useAxios from "../../../../../../../Hooks/useAxios";

import useApp from "../../../../../../../Hooks/useApp";

import TableContext from "./TContext";
import usePouchCud from "./../../../../../Hooks/usePouchCud";

const TableActions = ({ doc }) => {
  const request = useAxios();
  const { setShowSuccessModal, setModalMessage } = useApp();
  const { data, setData } = useContext(TableContext);
  const { deleteDoc } = usePouchCud();

  const handleDelete = async () => {
    let res = await request({
      method: "DELETE",
      url: `store/allocation/${doc.id}`,
    });

    if (res !== "error") {
      setModalMessage("Assigned Inventory Deleted!");
      setShowSuccessModal(true);
      await deleteDoc({ name: "allocations", doc: res });
    }

    let newDocs = data.filter((row) => (row.id === doc.id ? false : true));
    
    setData(newDocs);
  };

  return (
    <div className="flex-1">
      {/* <TableHorizontalActionBtn /> */}
      <div className=" gap-y-2 flex flex-col text-sm">
        <BtnPlain activeBgColor="white" bg="white" click={handleDelete}>
          <div className=" gap-x-2 flex items-center active:opacity-50 cursor-pointer">
            <p className="  text-red">
              <FaRegTrashAlt />
            </p>
          </div>
        </BtnPlain>
      </div>
    </div>
  );
};

export default TableActions;
